import { render } from "./AddNewMemberToGroup.vue?vue&type=template&id=2c81cdd8&scoped=true"
import script from "./AddNewMemberToGroup.vue?vue&type=script&lang=js"
export * from "./AddNewMemberToGroup.vue?vue&type=script&lang=js"

import "./AddNewMemberToGroup.vue?vue&type=style&index=0&id=2c81cdd8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c81cdd8"]])

export default __exports__